import { Component, OnInit, Input } from '@angular/core';
import { Center } from 'src/app/models/center-model/center.model';
import { CentersCentersService } from 'src/app/services/centers-services/centers-centers-service/centers-centers.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { MatDialog } from '@angular/material/dialog';
import { SpinnerService } from 'src/app/modules/spinner/spinner.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { ImageDialogComponent } from '../../shared-components/image-dialog/image-dialog.component';
import { MultimediaManagerComponent } from 'src/app/modules/multimedia-manager/multimedia-manager/multimedia-manager.component';

@Component({
  selector: 'app-centers-center-l-photo-editor-card',
  templateUrl: './centers-center-l-photo-editor-card.component.html',
  styleUrls: ['./centers-center-l-photo-editor-card.component.scss']
})
export class CentersCenterLPhotoEditorCardComponent implements OnInit {

  @Input() centerInfo: Center;
  @Input() title: string;
  @Input() width: string;
  @Input() height: string;
  showSpinner: boolean;

  constructor(private centersService: CentersCentersService,
              private userStorageService: UserStorageService,
              private snackbarService: SnackBarService,
              public dialog: MatDialog,
              private spinnerService: SpinnerService) { }

  ngOnInit() {
  }

  public updateImageCenter(imageUrl) {
    this.showSpinner = true;
    this.spinnerService.show('center-l-image-spinner');
    this.centersService.updateImageCenter(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), this.centerInfo.InternalId, imageUrl, 'L').subscribe(
      (res) => {
        this.centersService.refreshCenter();
        this.showSpinner = false;
        this.spinnerService.hide('center-l-image-spinner');
        this.snackbarService.open('validation-images.snackbar messages.update image success', 'success');
      },
      (error) => {
        this.centersService.refreshCenter();
        this.showSpinner = false;
        this.spinnerService.hide('center-l-image-spinner');
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public deleteAsset() {
    this.showSpinner = true;
    this.spinnerService.show('center-l-image-spinner');
    this.centersService.updateImageCenter(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), this.centerInfo.InternalId, null, 'L').subscribe(
      (res) => {
        this.centersService.refreshCenter();
        this.showSpinner = false;
        this.spinnerService.hide('center-l-image-spinner');
        this.snackbarService.open('validation-images.snackbar messages.update image success', 'success');
      },
      (error) => {
        this.centersService.refreshCenter();
        this.showSpinner = false;
        this.spinnerService.hide('center-l-image-spinner');
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public zoom() {
    const dialogRef = this.dialog.open(ImageDialogComponent, { data: { image: this.centerInfo.ImageL, info: { title: this.title, subtitle: this.width + 'x' + this.height }}});
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        if (res === 'upload') {
          this.uploadPhotoClicker();
        } else if (res === 'delete') {
          this.deleteAsset();
        }
      }
    });
  }

  public uploadPhotoClicker() {
    const dialogRef = this.dialog.open(MultimediaManagerComponent, { data: { multi: false, cropper: { width: 400, height: 250 } } });
    dialogRef.beforeClosed().subscribe(
      (result) => {
        if (result) {
          this.updateImageCenter(result[0].Url);
        }
      }
    );
  }
}
